import { useEffect, useState } from "react";
function useViewportDimensions() {
  let heightPercentage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.8;
  let widthPercentage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.8;
  function getViewportDimensions() {
    const height = window.innerHeight * heightPercentage;
    const width = window.innerWidth * widthPercentage;
    return {
      height,
      width
    };
  }
  const {
    0: dimensions,
    1: setDimensions
  } = useState(getViewportDimensions());
  useEffect(() => {
    const handleResize = () => {
      setDimensions(getViewportDimensions());
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [heightPercentage, widthPercentage]);
  return dimensions;
}
export default useViewportDimensions;